import { Dialog } from '@cimplico/components';
import { useStartWorkpaperExport } from '../../../queries/use-start-workpaper-export';

type ExportWorkpaperDialogProps = {
    workpaperId: string;
    isOpen: boolean;
    onClose: () => void;
};

function ExportWorkpaperDialog({ workpaperId, isOpen, onClose }: ExportWorkpaperDialogProps): JSX.Element {
    const startWorkpaperExportQuery = useStartWorkpaperExport(workpaperId);

    function exportWorkpaper(): void {
        startWorkpaperExportQuery.mutate(
            {},
            {
                onSuccess: () => {
                    onClose();
                },
            }
        );
    }

    return (
        <Dialog
            title="Export Workpaper"
            description="Do you want to export this workpaper? Exporting may take a few minutes. You can leave this page at any time."
            onClose={onClose}
            onPrimaryActionClick={exportWorkpaper}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Export"
            secondaryAction="Cancel"
            type="info"
            isLoading={startWorkpaperExportQuery.isLoading}
        />
    );
}

export default ExportWorkpaperDialog;
